import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@fleetops/firebase'
import { firestorePaths, type DashboardAggregate, type EstimateBaselines } from '@fleetops/types'
import { useSession } from '@/store/auth.store'
import { subscriptionError } from '@/lib/firestoreError'

// Single-doc realtime listener — O(1) reads, replaces scanning the whole
// damages collection for current-state headline counters.
export function useDashboardSummary() {
  const session = useSession()
  const [data, setData] = useState<DashboardAggregate | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!session) return
    return onSnapshot(
      doc(db, firestorePaths.dashboardAggregate(session.tenantId)),
      (snap) => {
        setData(snap.exists() ? (snap.data() as DashboardAggregate) : null)
        setIsLoading(false)
      },
      subscriptionError('os indicadores do dashboard', () => setIsLoading(false)),
    )
  }, [session?.tenantId])

  const openCount = data ? data.total - (data.byStatus?.['closed'] ?? 0) : 0
  return { summary: data, openCount, isLoading }
}

// Accepted-estimate price baselines per `${location}_${severity}` bucket.
// Consumed by the auto-approval engine (step 3) and cost analytics.
export function useEstimateBaselines() {
  const session = useSession()
  const [data, setData] = useState<EstimateBaselines | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!session) return
    return onSnapshot(
      doc(db, firestorePaths.estimateBaselines(session.tenantId)),
      (snap) => {
        setData(snap.exists() ? (snap.data() as EstimateBaselines) : null)
        setIsLoading(false)
      },
      subscriptionError('as referências de preços', () => setIsLoading(false)),
    )
  }, [session?.tenantId])

  return { baselines: data, isLoading }
}
